import React from 'react';

function Terms() {
  return (
    <main className="bg-grid min-h-screen">
      <section className="mx-auto max-w-4xl px-6 pb-16 pt-28 lg:px-10">
        <p className="text-sm font-semibold uppercase tracking-[0.18em] text-accent/90">Terms</p>
        <h1 className="mt-3 text-3xl font-semibold tracking-tight text-white sm:text-4xl">Terms of Service</h1>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg">
          By working with Merchy or submitting a project inquiry, you agree that any final scope, deliverables,
          timeline, and fees are defined in a separate proposal or agreement.
        </p>

        <div className="mt-10 space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-white">Use of Services</h2>
            <p className="mt-2 text-sm leading-relaxed text-gray-400">
              Merchy provides software, automation, AI assistant, integration, and workflow consulting services for
              business operations. Website inquiries do not create a project engagement until both sides agree on scope.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">Project Scope</h2>
            <p className="mt-2 text-sm leading-relaxed text-gray-400">
              Each project may require discovery, workflow mapping, technical review, proposal approval, testing, and
              launch support. Requirements that change after approval may require updated scope or pricing.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">Client Responsibilities</h2>
            <p className="mt-2 text-sm leading-relaxed text-gray-400">
              Clients are responsible for providing accurate process details, timely feedback, access to approved tools
              or accounts when required, and final business decisions related to their operations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">No Universal Automation Guarantee</h2>
            <p className="mt-2 text-sm leading-relaxed text-gray-400">
              Not every workflow can or should be automated. Merchy recommends practical solutions based on business
              value, technical feasibility, privacy, reliability, and maintainability.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">Third-Party Platforms</h2>
            <p className="mt-2 text-sm leading-relaxed text-gray-400">
              Some solutions depend on third-party APIs, messaging providers, hosting platforms, or software tools.
              Their pricing, policies, limits, and availability may affect project behavior or ongoing costs.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white">Contact</h2>
            <p className="mt-2 text-sm text-gray-400">support@merchyapp.online</p>
          </section>
        </div>
      </section>
    </main>
  );
}

export default Terms;
